module.exports = __webpack_public_path__ + "static/media/reg3kz.f285b27a.pdf";